<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">挂车号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.hangPlate"
          clearable
        >
        </el-input>
        <span class="fonints">司机名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.driverName"
          clearable
        >
        </el-input>
        <span class="fonints">车辆所有人</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.carowner"
          clearable
        >
        </el-input>
        
        
      </div>
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
          <span class="fonints">排放标准</span>
        <div class="select_box1">
          <el-select v-model="conditions.discharge" class="m-2" clearable>
            <el-option
              v-for="item in dischargeoptions"
              :key="item.val"
              :label="item.val"
              :value="item.val"
            />
          </el-select>
        </div>
        <span class="fonints">所属车队</span>
        <el-input
          style="width: 230px"
          placeholder="请输入关键词"
          v-model="conditions.fleetname"
          clearable
        >
        </el-input>
        <span class="fonints">审核状态</span>
        <div class="select_box1">
          <el-select v-model="conditions.useStatus" class="m-2" clearable>
            <el-option
              v-for="item in useStatusList"
              :key="item.val"
              :label="item.name"
              :value="item.val"
            />
          </el-select>
        </div>
      </div>
      <div class="componentSty_content_title_flex_button">
        <button class="buttons" @click="selectlist">查询</button>
        <button class="buttons" style="color: #17B6A1;background-color: #F3F4F5;" @click="clearlist">重置</button>
        <button class="buttons" @click="exportCarList">导出</button>
      </div>
    </div>
      
      
      <div class="componentSty_content_table" style="top: 90px;border:none">
        <el-table
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          border
          height="80%"
        >
          <el-table-column
            show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
     
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码">
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            prop="hangPlate"
            label="挂车号码"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="driverName"
            label="司机姓名"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="telephone"
            label="手机号码"
          >
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="fleetName"
            label="所属车队"
          >
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip  :render-header="renderHeader"
            prop="carowner"
            label="车辆所有人"
          >
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="discharge"
            label="排放标准"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="cartype"
            label="车辆类型"
          >
          <template v-slot="res">
              <span>{{
                res.row.cartype==1?'新能源车':res.row.cartype==2?'燃油车':'天然气车'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="限定载重">
            <template v-slot="res">
              <span>{{
                res.row.truckTypecode && res.row.truckTypecode + '吨'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="iscustoms" label="海关监管">
            <template v-slot="res">
              <span>{{
                res.row.iscustoms==1?"监管":"非监管"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="issend" label="推送">
            <template v-slot="res">
              <span>{{
                res.row.issend == 2 ? "已推送" : "未推送"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="状态">
            <template v-slot="res">
              <span
                v-if="res.row.useStatus == 0"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >待审核</span
              >
              <span
                v-if="res.row.useStatus == 1"
                class="el_spanfontstyle"
                style="color: #13d168"
                >正常</span
              >
              <span
                v-if="res.row.useStatus == 2"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >审核未通过</span
              >
              <span
                v-if="res.row.useStatus == 3"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >停用</span
              >
              <span
                v-if="res.row.useStatus == 4"
                class="el_spanfontstyle"
                style="color: orange"
                >待缴费</span
              >
              <span
                v-if="res.row.useStatus == 5"
                class="el_spanfontstyle"
                style="color: #fe5a24"
                >待发卡</span
              >
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <el-tooltip content="禁用" effect="light">
                <span
                  v-if="res.row.useStatus == 1"
                  class="iconfont icon-jinyong"
                  @click="checkState(res.row)"
                ></span>
              </el-tooltip>
                <el-tooltip content="启用" effect="light">
                <span
                  v-if="res.row.useStatus == 3"
                  class="iconfont icon-qiyong"
                  @click="checkState(res.row)"
                ></span>
              </el-tooltip>
              <el-tooltip content="编辑" effect="light">
                <span
                class="iconfont icon-xiugai"
                @click="itemparticulars(res.row)"
              ></span>
              </el-tooltip>
              <el-tooltip content="推送" effect="light">
                <i class="el-icon-s-promotion" @click="pushtoproCarInfo(res.row)"></i>
              </el-tooltip>
              
              
            </template>
          </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">车辆合计:{{ arrlist.total }}辆</span>
        </div>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.total"
            :current-page="conditions.page"
            @current-change="getMemberlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import { mapMutations, mapState } from 'vuex';
import mSelect from '@/components/mSelect.vue';
import { antiShake, printExcel } from '@/plugins/other.js';
export default {
  name: 'addcarlistinfo',
  data() {
    return {
      connState: 1,
      isReading: false, //读卡状态 。
      listitem: [{ name: '会员管理' }, { name: '会员列表' }],
      arrlist: [],
      idcard: '',
      conditions: {
        page: 1,
        limit: 20,
        order: 'desc',
        sidx: 'gmt_modified',
        discharge: '',
      },
      stateName: '全部',
      selectastrict: ['全部', '空闲中', '充电中'], //作业节点
      dischargeoptions: [],
      useStatusList:[
        {name:'待审核',val:0},
        {name:'正常',val:1},
        {name:'审核未通过',val:2},
        {name:'停用',val:3},
      ]
    };
  },
  components: {
    mSelect,
    mTitle,
  },
  computed: {
    ...mapState(['conditionsList']),
  },
  watch: {
    idcard(nval) {
      if (nval == '读卡器打开成功!' || nval === '读卡器连接异常!') return '';
      this.conditions.rfid = nval;
      this.getMemberlist();
    },
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({
    //     key: this.$route.path,
    //     val: {
    //       page: 1,
    //       limit: 20,
    //       order: "desc",
    //       sidx: "gmt_modified",
    //     },
    //   });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    //   order: "desc",
    //   sidx: "gmt_modified",
    // };
    console.log(this.$route.query.obj);
    // console.log(JSON.parse(this.$route.query));
    if(this.$route.query.obj){
      this.conditions.fleetname=JSON.parse(this.$route.query.obj).shortname
      this.conditions.discharge=JSON.parse(this.$route.query.obj).discharge
      this.conditions.useStatus=JSON.parse(this.$route.query.obj).useStatus
    }
    this.getMemberlist();
    this.getdischargeoptions();
  },

  methods: {
    ...mapMutations(['createConditions']),
    //推送生产
		pushtoproCarInfo(row) {
			this.$messageBox.confirm('是否推送该车辆?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async ()=>{
					const res = await this.$http(
            'api1',
            "driver/car/pushCarToPro",
						"post",
					  { id: row.id }
					)
					if (res.data.code !== 0) {
						this.$message.error(res.data.msg);
						throw res.data;
					}
          this.$message({
						type: 'success',
						message: '推送成功'
					});
					this.getMemberlist();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '推送失败'
					});
				});
			
		},
    async getMemberlist(num) {
      typeof num === 'number' && (this.conditions.page = num);
      const { data } = await this.$http(
        'api1',
        '/driver/car/list',
        'get',
        this.conditions
      );
      if (!data || data.msg != 'success')
        return this.$message.error('获取数据失败');
      this.arrlist = data.page;
    },
    async checkState(row) {
      if (row.useStatus == 3) {
        row.useStatus = 1;
        const { data } = await this.$http(
          'api1',
          '/driver/car/carInitiateMode',
          'post',
          { ids: [row.id] }
        );
        if (!data || data.msg != 'success')
          return this.$message.error('修改失败');
        this.$message.success('启用成功');
      } else {
        row.useStatus = 3;
        const { data } = await this.$http(
          'api1',
          '/driver/car/carDeadStatus',
          'post',
          { ids: [row.id] }
        );
        if (!data || data.msg != 'success')
          return this.$message.error('修改失败');
        this.$message.success('停用成功');
      }
    },
    exportCarList(){
      printExcel.call(
        this,
        '/driver/car/exportCarList',
        '车辆列表',
        this.conditions,
        'get'
      );
    },
    // 排放标准
    async getdischargeoptions() {
      const { data } = await this.$http(
        'api1',
        '/sys/dic/list?dictionaryType=排放标准',
        'get'
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.dischargeoptions = data.data;
    },
    itemparticulars(res) {
      window.sessionStorage.setItem('infoid', res.id);
      this.$router.push({ name: 'memverpartivulars' });
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getMemberlist();
      });
    },
    clearlist(){
      this.conditions.plate=""
      this.conditions.hangPlate=""
      this.conditions.driverName=""
      this.conditions.carowner=""
      this.conditions.discharge=""
      this.conditions.fleetname=""
      this.getMemberlist();
    }
  },
  beforeDestroy() {
    window.ws && window.ws.close();
    window.ws = null;
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
